export default from './post-page-footer';



// WEBPACK FOOTER //
// ./app/containers/post-page-footer/index.js